import { DOMAIN, FONT, WARM } from "@shared/brand";
export function ErrorFallback() {
  return (
    <div className="min-h-screen flex items-center justify-center bg-[#FAF7F1] p-6">
      <div className="max-w-md text-center">
        <h1
          className="text-2xl mb-3"
          style={{ fontFamily: FONT.serif, color: WARM.ink }}
        >
          Something went wrong on our end.
        </h1>
        <p
          className="text-[#2B2A26] mb-6"
          style={{ fontFamily: FONT.sans }}
        >
          We've been automatically notified and are looking into it.
          In the meantime, please refresh the page or reach out at{" "}
          <a href={`mailto:support@${DOMAIN.primary}`} className="underline">
            support@{DOMAIN.primary}
          </a>
          .
        </p>
        <button
          type="button"
          onClick={() => window.location.reload()}
          className="px-5 py-2 rounded-lg bg-[#4F6B51] text-white"
          style={{ fontFamily: FONT.sans }}
        >
          Reload the page
        </button>
      </div>
    </div>
  );
}
